import { ATTACHMENTS } from '../../api/endpoints';
import { baseApi, listTags } from './baseApi';

const multipart =
  typeof FormData !== 'undefined'
    ? { headers: { 'Content-Type': 'multipart/form-data' } }
    : {};

export const documentsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getAttachments: build.query({
      query: ({ model_type, model_id, ...rest } = {}) => ({
        url: ATTACHMENTS.LIST,
        method: 'GET',
        params: { model_type, model_id, ...rest },
      }),
      providesTags: (result) => listTags('Document', result),
    }),
    uploadAttachment: build.mutation({
      query: (formData) => ({
        url: ATTACHMENTS.LIST,
        method: 'POST',
        data: formData,
        ...multipart,
      }),
      invalidatesTags: [{ type: 'Document', id: 'LIST' }],
    }),
    downloadAttachment: build.mutation({
      query: (id) => ({
        url: ATTACHMENTS.DOWNLOAD(id),
        method: 'GET',
        responseType: 'blob',
      }),
    }),
    deleteAttachment: build.mutation({
      query: (id) => ({ url: ATTACHMENTS.BY_ID(id), method: 'DELETE' }),
      invalidatesTags: (_r, _e, id) => [
        { type: 'Document', id },
        { type: 'Document', id: 'LIST' },
      ],
    }),
    downloadLeadFileByPath: build.mutation({
      query: (path) => ({
        url: ATTACHMENTS.DOWNLOAD_BY_PATH,
        method: 'POST',
        data: typeof path === 'string' ? { path } : path,
        responseType: 'blob',
      }),
    }),
  }),
});

export const {
  useGetAttachmentsQuery,
  useLazyGetAttachmentsQuery,
  useUploadAttachmentMutation,
  useDownloadAttachmentMutation,
  useDeleteAttachmentMutation,
  useDownloadLeadFileByPathMutation,
} = documentsApi;
